export default "__VITE_ASSET__TL7d6M85__"